"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../../../../../common/helpers/time");
function InstructorRequestTimeOffDayController($stateParams, $state, TimeoffRequestsModel, FlashService) {
    var vm = this;
    vm.date = new Date();
    vm.requestDayOff = {};
    vm.requestType = {
        dayOff: false,
        moreThanDay: false,
        partialDay: false,
    };
    vm.requestDayOff = {};
    vm.submitDayRequest = submitDayRequest;
    vm.updateDayOffDate = updateDayOffDate;
    vm.updateFromTime = updateFromTime;
    vm.updateToTime = updateToTime;
    init();
    function init() {
        //set initial value for time pickers
        vm.requestDayOff.from = new Date();
        vm.requestDayOff.from.setHours(9);
        vm.requestDayOff.from.setMinutes(0);
        vm.requestDayOff.to = new Date();
        vm.requestDayOff.to.setHours(12);
        vm.requestDayOff.to.setMinutes(0);
    }
    function updateDayOffDate(newDate) {
        vm.requestDayOff.date = newDate.selected[0];
    }
    function updateFromTime(newTime) {
        vm.requestDayOff.from = newTime.selected[0];
    }
    function updateToTime(newTime) {
        vm.requestDayOff.to = newTime.selected[0];
    }
    function partialDayTimesAreInvalid() {
        var fromMinutes = vm.requestDayOff.from.getHours() * 60 +
            vm.requestDayOff.from.getMinutes();
        var toMinutes = vm.requestDayOff.to.getHours() * 60 + vm.requestDayOff.to.getMinutes();
        return toMinutes <= fromMinutes;
    }
    function submitDayRequest(isValid) {
        vm.submitted = true;
        if (isValid) {
            if (vm.requestType.partialDay === true && partialDayTimesAreInvalid()) {
                FlashService.setMessage({
                    type: "error",
                    message: "The end time must be after the start time.",
                });
                return;
            }
            if (vm.requestType.partialDay === false) {
                vm.requestDayOff.from = new Date();
                vm.requestDayOff.from.setHours(0);
                vm.requestDayOff.from.setMinutes(0);
                vm.requestDayOff.from.setSeconds(0);
                vm.requestDayOff.to = new Date();
                vm.requestDayOff.to.setHours(23);
                vm.requestDayOff.to.setMinutes(59);
                vm.requestDayOff.to.setSeconds(59);
            }
            var dateStr = (0, time_1.toYMD)(vm.requestDayOff.date);
            var fromTimeStr = (0, time_1.formatDateTime)(vm.requestDayOff.from, "HH:mm:ss");
            var toTimeStr = (0, time_1.formatDateTime)(vm.requestDayOff.to, "HH:mm:ss");
            var begin = new Date("".concat(dateStr, " ").concat(fromTimeStr));
            var end = new Date("".concat(dateStr, " ").concat(toTimeStr));
            //console.log(dateStr, fromTimeStr, toTimeStr, begin, end);
            var request = {
                user_id: $stateParams.instructorId,
                begin: (0, time_1.formatDateTime)(begin, "YYYY-MM-DD HH:mm:ss"),
                end: (0, time_1.formatDateTime)(end, "YYYY-MM-DD HH:mm:ss"),
                type: vm.requestType.partialDay ? "partial" : "full",
                status: "Pending",
                reason: vm.requestDayOff.reason,
            };
            TimeoffRequestsModel.create(request).then(function (response) {
                FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                vm.submitted = false;
                $state.go("drivecoach.admin.instructors.view.timeoffrequests", { instructorId: $stateParams.instructorId }, { reload: true });
            });
        }
        else {
            FlashService.setMessage({
                type: "error",
                message: "Please fill the form.",
            });
        }
    }
}
InstructorRequestTimeOffDayController.$inject = [
    "$stateParams",
    "$state",
    "TimeoffRequestsModel",
    "FlashService",
];
exports.default = InstructorRequestTimeOffDayController;
